import * as React from "react";
import { styled } from "@mui/material/styles";
import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Chip,
} from "@mui/material";
import { CgEye } from "react-icons/cg";
import { titleCase } from "change-case-all";
import { useNavigate } from "react-router-dom";
import { tableCellClasses } from "@mui/material/TableCell";

import pages from "../../../constants/pages";
import { colors } from "../../css components/Style";
import { TextAvatar } from "../../../components";

const Icon = styled(IconButton)`
  border: 1px solid ${colors?.sideBarColor};
  color: ${colors?.sideBarColor};
  height: 35px;
  width: 35px;
  margin: 0 5px;
  padding: 0 5px;
  &:hover {
    border: 1px solid ${colors?.sideBarColor};
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }
`;

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: colors.iconColor,
    color: "#fff",
    fontSize: "11px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    backgroundColor: "#F9F9F9",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  ".MuiTableCell-root": {
    border: "none",
    padding: "10px",
    fontSize: "12px",
  },

  "&:nth-of-type(2n+1)": {
    backgroundColor: "rgba(249, 249, 249, 1)",
  },

  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function List({ templates, currentAgent }) {
  const navigate = useNavigate();

  return (
    <TableContainer sx={{ borderRadius: "10px" }} component={Paper}>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead style={{ height: "65px" }}>
          <TableRow>
            <StyledTableCell />

            <StyledTableCell>Template Name</StyledTableCell>
            <StyledTableCell>Template Category</StyledTableCell>
            <StyledTableCell>Template status</StyledTableCell>
            <StyledTableCell>Template Header Type</StyledTableCell>
            <StyledTableCell>Template Body</StyledTableCell>
            <StyledTableCell>Action</StyledTableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {templates?.temp_obj?.map((template) => (
            <StyledTableRow>
              <StyledTableCell component="th" scope="row">
                <TextAvatar
                  size={{
                    height: "30px",
                    width: "30px",
                  }}
                  userName={template.name}
                />{" "}
              </StyledTableCell>

              <StyledTableCell component="th" scope="row">
                {template.name}
              </StyledTableCell>

              <StyledTableCell component="th" scope="row">
                {template.category || "N.A."}
              </StyledTableCell>

              <StyledTableCell component="th" scope="row">
                <StatusChip template={template} />
              </StyledTableCell>

              <StyledTableCell component="th" scope="row">
                {template?.template_header?.type
                  ? titleCase(template?.template_header?.type)
                  : "N.A."}
              </StyledTableCell>

              <StyledTableCell>
                {template.template_body?.text.slice(0, 20) +
                  (template.template_body?.text.length > 20 ? "..." : ".")}
              </StyledTableCell>

              <StyledTableCell>
                <Tooltip title="View Template">
                  <Icon
                    onClick={() =>
                      navigate(
                        pages.templateDetails.route +
                          template._id +
                          "?agentID=" +
                          currentAgent.ID +
                          "&agentName=" +
                          currentAgent.name +
                          "&mode=view"
                      )
                    }
                  >
                    <CgEye style={{ height: "20px", width: "20px" }} />
                  </Icon>
                </Tooltip>
              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  function StatusChip({ template }) {
    let color;
    let label;
    if (template.verified_status_id === "8360b5eca314424a9d56c37004ccecc9") {
      color = colors.green;
      label = "Approved";
    }

    if (template.verified_status_id === "531c1247d1ca4329b4eef4596a099b52") {
      color = colors.yellow;
      label = "Pending";
    }

    if (template.verified_status_id === "01d6406c9c3348d78cbdd08974808cbe") {
      color = colors.error;
      label = "Disabled";
    }

    if (template.verified_status_id === "c280844cac4643698021059955d6bbe5") {
      color = colors.error;
      label = "Rejected";
    }

    return (
      <Chip
        style={{
          position: "relative",
          left: "-13px",
          fontSize: "13px",
          backgroundColor: color,
          color: "#fff",
        }}
        label={label}
      />
    );
  }
}
